import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const UnivapayPayment = () => {
  return <CommonProcess />;
};

export default UnivapayPayment;
